<style>
    .nav-link {
        color:#343a40 !important;
    }
    .nav-link.active {
        color:red !important;
    }
</style>
<template>
<div v-if="$zutil.pwaMobile()==1">
    <div class="container-fluid fixed-bottom mt-3 " style="background-color: #18191A;">
        <div class="row align-center mt-3 mb-3">
            <div class="col-3 text-align-center ">
                <inertia-link :href='$route("landing.utama")' v-bind:class="activetab('utama')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-home font-16 me-2"></i>Utama
                </inertia-link>

            </div>
            <div class="col-3 text-align-center ">
                <inertia-link :href='$route("landing.carian")' v-bind:class="activetab('carian')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fas fa-search font-16 me-2"></i>Carian</inertia-link>
            </div>
            <template v-if="auth.user.id">
            <div class="col-3 text-align-center">
                <inertia-link :href='$route("landing.transaksi")' v-bind:class="activetab('transaksi')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-list-alt font-16 me-2"></i>Transaksi</inertia-link>
            </div>
            <div class="col-3 text-align-center">
                <inertia-link :href='$route("landing.kegemaran")' v-bind:class="activetab('kegemaran')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-file-invoice font-16 me-2"></i>Bil</inertia-link>
            </div>
            </template>
        </div>
    </div> 

    <!-- <div class="container-fluid tab-nav-container fixed-bottom">
    <div class="tab purple "  v-bind:class="activetab('utama')">
        <inertia-link :href='$route("landing.utama")' style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-home font-16 me-2"></i>Halaman Utama</inertia-link>
    </div>
    <div class="tab pink" v-bind:class="activetab('carian')" :href='$route("landing.carian")'  >
        <inertia-link :href='$route("landing.carian")' style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fas fa-search font-16 me-2"></i>Carian iBayaq</inertia-link>

    </div>
    <div class="tab yellow" v-bind:class="activetab('transaksi')" :href='$route("landing.transaksi")'>
        <inertia-link :href='$route("landing.transaksi")' style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-list-alt font-16 me-2"></i>Senarai Transaksi</inertia-link>

    </div>
    <div class="tab teal" v-bind:class="activetab('kegemaran')" :href='$route("landing.kegemaran")'>
        <inertia-link :href='$route("landing.kegemaran")'  style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-file-invoice font-16 me-2"></i>Bil Didaftar</inertia-link>
    </div>
    </div> -->

    <!-- <div class="tab-nav-container fixed-bottom container-fluid">
  <div class="tab purple" v-bind:class="activetab('utama')">
    <i class="fas fa-home"></i>
    <a :href='$route("landing.utama")'>Halaman Utama</a>
  </div>
  <div class="tab pink" v-bind:class="activetab('carian')">
    <i class="far fa-heart"></i>
    <a :href='$route("landing.carian")'>Carian iBayaq</a>
  </div>
  <div class="tab yellow" v-bind:class="activetab('transaksi')">
    <i class="fas fa-search"></i>
    <a :href='$route("landing.transaksi")'>Senarai Transaksi</a>
  </div>
  <div class="tab teal" v-bind:class="activetab('kegemaran')">
    <i class="far fa-bell"></i>
    <a :href='$route("landing.kegemaran")'>Bil Didaftarkan</a>
  </div>
</div>-->

        

</div>
<div v-else-if="$zutil.pwaMobile()==2">
    <div class="container-fluid fixed-bottom bg-light mt-3 ">
        <div class="row align-center mt-3">
            <div class="col-4 text-align-center ">
                <inertia-link :href='$route("landing.carian")' v-bind:class="activetab('carian')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fas fa-search font-16 me-2"></i></inertia-link>
                <p style="text-align: center;">Carian</p>
            </div>
            <template v-if="auth.user.id">
            <div class="col-4 text-align-center">
                <inertia-link :href='$route("landing.transaksi")' v-bind:class="activetab('transaksi')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-list-alt font-16 me-2"></i></inertia-link>
                <p style="text-align: center;">Transaksi Bayaran</p>
            </div>
            <div class="col-4 text-align-center">
                <inertia-link :href='$route("landing.kegemaran")' v-bind:class="activetab('kegemaran')" style="text-decoration: none;background-color: transparent;text-align: center;"><i class="fa fa-file-invoice font-16 me-2"></i></inertia-link>
                <p style="text-align: center;">Bil Didaftarkan</p>
            </div>
            </template>
        </div>
    </div>
</div>

<div v-else>
    <div class="card-header">
        <div class="row align-items-center">
            <div class="col">                      
                <h4 class="card-title">

                    </h4>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <inertia-link :href='$route("landing.carian")' v-bind:class="activetab('carian')" style="text-decoration: none;"><i class="dripicons-search font-16 me-2"></i> Carian </inertia-link>
                        </li>
                        <template v-if="auth.user.id">
                            <!-- <span class="m-3">|</span> -->
                            <li class="nav-item">
                                <inertia-link :href='$route("landing.transaksi")' v-bind:class="activetab('transaksi')" style="text-decoration: none;"><i class="mdi  dripicons-network-3 font-16 me-2"></i>Transaksi Bayaran</inertia-link>
                            </li>

                            <!-- <span class="m-3">|</span> -->
                            <li class="nav-item">
                                <inertia-link :href='$route("landing.kegemaran")' v-bind:class="activetab('kegemaran')" style="text-decoration: none;"><i class="mdi mdi-bookmark-outline font-16 me-2"></i>Bil Didaftarkan</inertia-link>
                            </li>
                            
                        </template>
                    </ul>


                    
            </div><!--end col-->
        </div>                               
    </div><!--end card-header--> 
    
    
     
</div>
</template>

<script type="text/javascript">
    import { GrowBottomNavigation } from "bottom-navigation-vue";
    import "bottom-navigation-vue/dist/style.css";

    import { InertiaLink } from "@inertiajs/inertia-vue3";


    const tabs= document.querySelectorAll(".tab");
        tabs.forEach((clickedTab)=>{
        clickedTab.addEventListener('click',()=>{
        tabs.forEach((tab=>{
            tab.classList.remove("activetab");
        }))
        clickedTab.classList.add("activetab");
        const clickedTabBGColor=getComputedStyle
        (clickedTab).getPropertyValue(
            "color"
        );
        document.body.style.background=clickedTabBGColor;
    });
});

	export default {
	components: {
        GrowBottomNavigation,
        InertiaLink
	},
	setup () {
        

	},
	props: {
	    auth: [Array, Object],
        link: [String],
	},
	data() {
        
	    return {
	  no_rujukan: '',
	  senarai : [],
	  total_carian : 0.00,
	  total_pilih : 0.00,
	  cari : 0,
      selected: 1,
    options: [
      { id: 1, icon: 'fa fa-home', title: 'Halaman Utama', color: '#5639af', path: "landing.utama"},
      { id: 2, icon: 'fa fa-search', title: 'Carian', color: '#ac4793', path: "landing.carian" },
      { id: 3, icon: 'fa fa-list-alt', title: 'Senarai Transaksi', color: '#e2a93a' , path: "landing.transaksi"},
      { id: 4, icon: 'fa fa-file-invoice', title: 'Bil Didaftarkan', color: '#4493a7' , path: "landing.kegemaran"}
    ],
	}},
	methods: {
        back() {
            window.history.back();
        },
        activetab(active) {
            return this.link == active ? 'nav-link active' : 'nav-link';
        },
        logout() {
            this.$inertia.get('logout')
        },
	    password() {
            this.$inertia.get('changePassword')
        },
	},
    mounted() {
        // override default setting
        console.log(this.link);
    
        
        
    }
}
</script>

